import { FieldTypeENUM } from '../models/dynamic-form.model';
import { ScaleDefinition } from '../models/dynamic-scale.model';
import { TCT_SCALE } from './scales';
import { NINE_HOLE_PEG_TEST_SCALE } from './scales/9hpt';
import { BARTHEL_SCALE } from './scales/barthel';
import { BRADEN_SCALE } from './scales/braden';
import { CAT_SCALE } from './scales/cat';
import { DASH_SCALE } from './scales/dash';
import { IPAQ_SCALE } from './scales/ipaq';
import { MAS_SCALE } from './scales/mas';
import { MINIMENTAL_SCALE } from './scales/minimental';
import { MOTRICITY_INDEX_SCALE } from './scales/motricity';
import { NDI_SCALE } from './scales/ndi';
import { NRS_SCALE } from './scales/nrs';
import { RMDQ_SCALE } from './scales/rmdq';
import { SPPB_SCALE } from './scales/sppb';
import { VAS_SCALE } from './scales/vas';
export interface IFieldType {
  type: FieldTypeENUM;
  descrizione: string;
  icon: string;
  value: string | number | boolean | Date;
  placeholder: string;
  config?: ScaleDefinition;
}

export const FIELD_TYPES: IFieldType[] = [
  {
    type: FieldTypeENUM.TEXT,
    descrizione: 'Testo',
    icon: 'text_fields',
    placeholder: 'Risposta testuale breve',
    value: '',
  },
  {
    type: FieldTypeENUM.NUMBER,
    descrizione: 'Risposta numerica',
    icon: '123',
    placeholder: 'ES: 100',
    value: null,
  },
  {
    type: FieldTypeENUM.DATE,
    descrizione: 'Data',
    icon: 'calendar_month',
    placeholder: new Date().toISOString().split('T')[0],
    value: null,
  },
  {
    type: FieldTypeENUM.CHECKBOX,
    descrizione: 'Scelta multipla',
    icon: 'check_box',
    placeholder: 'Scelta multipla',
    value: null,
  },
  {
    type: FieldTypeENUM.SELECT,
    descrizione: 'Lista opzioni',
    icon: 'more_vert',
    placeholder: 'Lista di opzioni',
    value: null,
  },
  {
    type: FieldTypeENUM.RADIOBUTTON,
    descrizione: 'Scelta singola',
    icon: 'radio_button_checked',
    placeholder: 'Scelta singola',
    value: null,
  },
  {
    type: FieldTypeENUM.TOGGLE,
    descrizione: 'Si/No',
    icon: 'toggle_off',
    placeholder: 'Risposta unica',
    value: false,
  },
  {
    type: FieldTypeENUM.UPLOADFILE,
    descrizione: 'Caricamento file',
    icon: 'upload_file',
    placeholder: 'Caricamento file',
    value: null,
  },
  {
    type: FieldTypeENUM.TEXTAREA,
    descrizione: 'Risposta testuale lunga',
    icon: 'text_fields_alt',
    placeholder: 'Risposta testuale lunga',
    value: null,
  },
  {
    type: FieldTypeENUM.ACCORDION,
    descrizione: 'Accordion',
    icon: 'expand_more',
    placeholder: 'Descrizione accordion',
    value: null,
  },
  {
    type: FieldTypeENUM.PRIORITY,
    descrizione: 'Priorità',
    icon: 'error_outline',
    placeholder: 'Select priorità',
    value: null,
  },
  {
    type: FieldTypeENUM.TYPOLOGY,
    descrizione: 'Lista tipologica',
    icon: 'list_alt_check',
    placeholder: '',
    value: null,
  },
  {
    type: FieldTypeENUM.MONISER,
    descrizione: 'Moniser',
    icon: 'upload_file',
    placeholder: 'Moniser',
    value: '',
  },
];

export const SCALE_FIELD_TYPE: IFieldType[] = [
  {
    type: FieldTypeENUM.BARTHEL_SCALE,
    descrizione: 'Scala di Barthel',
    icon: 'assessment',
    placeholder: 'Scala di Barthel',
    value: null,
    config: BARTHEL_SCALE,
  },
  {
    type: FieldTypeENUM.BRADEN_SCALE,
    descrizione: 'Braden Scale',
    icon: 'assessment',
    placeholder: 'Braden Scale',
    value: null,
    config: BRADEN_SCALE,
  },
  {
    type: FieldTypeENUM.MINIMENTAL_SCALE,
    descrizione: 'Minimental Scale',
    icon: 'assessment',
    placeholder: 'Minimental Scale',
    value: null,
    config: MINIMENTAL_SCALE,
  },
  {
    type: FieldTypeENUM.VAS_SCALE,
    descrizione: 'VAS Scale',
    icon: 'assessment',
    placeholder: 'VAS Scale',
    value: null,
    config: VAS_SCALE,
  },
  {
    type: FieldTypeENUM.MAS,
    descrizione: 'MAS',
    icon: 'assessment',
    placeholder: 'MAS',
    value: null,
    config: MAS_SCALE,
  },
  {
    type: FieldTypeENUM.NDI,
    descrizione: 'NDI',
    icon: 'assessment',
    placeholder: 'NDI',
    value: null,
    config: NDI_SCALE,
  },
  {
    type: FieldTypeENUM.NRS_SCALE,
    descrizione: 'NRS Scale',
    icon: 'assessment',
    placeholder: 'NRS',
    value: null,
    config: NRS_SCALE,
  },
  {
    type: FieldTypeENUM.RMDQ,
    descrizione: 'RMDQ',
    icon: 'assessment',
    placeholder: 'RMDQ',
    value: null,
    config: RMDQ_SCALE,
  },
  {
    type: FieldTypeENUM.SPPB,
    descrizione: 'SPPB',
    icon: 'assessment',
    placeholder: 'SPPB',
    value: null,
    config: SPPB_SCALE,
  },
  {
    type: FieldTypeENUM.NINE_HOLE_PEG_TEST_SCALE,
    descrizione: '9 Hole Peg Test',
    icon: 'assessment',
    placeholder: '9HPT',
    value: null,
    config: NINE_HOLE_PEG_TEST_SCALE,
  },
  {
    type: FieldTypeENUM.CAT,
    descrizione: 'COPD Assessment Test (CAT)',
    icon: 'assessment',
    placeholder: 'COPD Assessment Test (CAT)',
    value: null,
    config: CAT_SCALE,
  },
  {
    type: FieldTypeENUM.DASH,
    descrizione: 'DASH',
    icon: 'assessment',
    placeholder: 'DASH Questionnaire',
    value: null,
    config: DASH_SCALE,
  },
  {
    type: FieldTypeENUM.IPAQ,
    descrizione: 'International Physical Activity Questionnaire (Short Form)',
    icon: 'assessment',
    placeholder: 'IPAQ',
    value: null,
    config: IPAQ_SCALE,
  },
  {
    type: FieldTypeENUM.MOTRICITY,
    descrizione: 'Motricity Index (MI)',
    icon: 'assessment',
    placeholder: 'Motricity Index (MI)',
    value: null,
    config: MOTRICITY_INDEX_SCALE,
  },
  {
    type: FieldTypeENUM.TCT,
    descrizione: 'TCT',
    icon: 'assessment',
    placeholder: 'TCT',
    value: null,
    config: TCT_SCALE,
  },
];

export const PREDEFINED_TYPES = [
  {
    type: FieldTypeENUM.NAZIONE,
    descrizione: 'Nazione',
    icon: 'flag',
    placeholder: 'Seleziona la nazione',
    value: null,
  },
  {
    type: FieldTypeENUM.CODICE_FISCALE,
    descrizione: 'Codice fiscale',
    icon: 'badge',
    placeholder: 'Inserisci il codice fiscale',
    value: null,
  },
  {
    type: FieldTypeENUM.EMAIL,
    descrizione: 'Email',
    icon: 'email',
    placeholder: "Inserisci l'email",
    value: null,
  },
  {
    type: FieldTypeENUM.TELEFONO,
    descrizione: 'Telefono',
    icon: 'phone',
    placeholder: 'Inserisci il telefono',
    value: null,
  },
  {
    type: FieldTypeENUM.REGIONI_PROVINCE_COMUNI,
    descrizione: 'Regione, Provincia, Comune',
    icon: 'location_city',
    placeholder: 'Seleziona la regione, la provincia e il comune',
    value: null,
  },
];
